export default "//file.bilionpass.com/japandx-web/0.0.1/static/airplane.7745659e-d8357c.svg";